import React from 'react'
const BlockEnterSubmit = () => <button type="submit" disabled style={{ display: 'none' }} aria-hidden="true" />
export default BlockEnterSubmit
